

export default class TranslationModel  {
	LangCode?: string = '';
	Name?: string = '';
	constructor(obj?: Partial<TranslationModel>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
